<template>
  <div id="contenedor">
    <v-layout row wrap>
      <v-flex xs12 sm12 md12>
        <v-card class="table" elevation="4">
          <v-toolbar flat elevation="4">
            <v-card class="icon">
              <v-icon
                style="margin-left: 30px; margin-top: 25px"
                color="white"
                x-large=""
                >mdi-map-marker-plus</v-icon
              >
            </v-card>
            <div class="usuario">PUNTOS</div>
            <v-spacer></v-spacer>
            <v-dialog v-model="dialog" max-width="500px" persistent>
              <template v-slot:activator="{ on }">
                <v-btn dark class="botonplus" v-on="on"
                  ><v-icon color="white">mdi-plus-thick</v-icon></v-btn
                >
              </template>
              <v-card style="display: flex; flex-direction: column; max-height: 90vh;">
                <v-card-title class="nav" style="flex-shrink: 0;">
                  <span class="headline" style="color: whitesmoke"
                    ><v-icon color="white">mdi-map-marker-plus</v-icon>
                    {{ formTitle }}</span
                  >
                </v-card-title>
                <!-- componente del modal para agregar y actualizar -->
                <v-card-text style="flex: 1 1 auto; overflow-y: auto; min-height: 0;">
                  <v-container grid-list-md>
                    <v-layout wrap>
                      <v-flex xs12 sm12 md12>
                        <v-text-field
                          v-model="editedItem.nombre"
                          label="Nombre"
                          mask="#############"
                        ></v-text-field>
                      </v-flex>
                      <v-flex xs12 sm12 md12>
                        <v-text-field
                          v-model="editedItem.direccion"
                          label="Dirección punto de venta"
                        ></v-text-field>
                      </v-flex>
                      <v-flex xs12 sm12 md12>
                        <v-select
                          item-value="prioridad"
                          item-text="prioridad"
                          :items="prioridad"
                          label="Prioridad"
                          v-model="editedItem.prioridad"
                        ></v-select>
                      </v-flex>
                      <v-flex xs12 sm12 md12>
                        <v-autocomplete
                          v-model="editedItem.idEmpresa"
                          label="Empresa"
                          :items="empresas"
                          item-text="nombre"
                          item-value="idEmpresa"
                          :rules="[
                            (v) => !!v || 'Se requiere seleccionar una empresa',
                          ]"
                          required
                        ></v-autocomplete>
                      </v-flex>
                      <v-flex xs12 sm12 md12>
                        <v-text-field
                          v-model="editedItem.codigoseta"
                          label="Codigo Seta (Ingresar Cero si no tiene codigo seta)"
                          type="number"
                        ></v-text-field>
                      </v-flex>
                    </v-layout>
                  </v-container>
                </v-card-text>
                <!-- botones para cancelar y agregregar y validacion de campos vacios -->
                <v-card-actions style="flex-shrink: 0;">
                  <v-spacer></v-spacer>
                  <v-btn color="#1D3C7F" dark @click="close">Cancelar</v-btn>
                  <v-btn
                    color="#1D3C7F"
                    dark
                    @click="save"
                    :disabled="
                      !editedItem.nombre ||
                      !editedItem.direccion ||
                      !editedItem.prioridad||
                      !editedItem.codigoseta ||
                      !editedItem.idEmpresa
                    "
                    >Guardar</v-btn
                  >
                </v-card-actions>
                <!-- <pre>{{editedItem}}</pre>  -->
              </v-card>
            </v-dialog>
          </v-toolbar>
          <br />
          <v-text-field
            v-model="search"
            append-icon="mdi-magnify"
            label="Buscar punto de venta"
            class="text-field"
            single-line
            color="#111c3d"
          ></v-text-field>
          <br />
          <v-data-table
            :headers="headers"
            :items="apps"
            :search="search"
            style="border: 2px solid #111c3d"
            class="elevation-3"
          >
            <!-- tabla donde se pintan los datos obtenidos del arreglo -->
            <template v-slot:[`item.action`]="{ item }">
              <v-icon small class="mr-2" @click="editItem(item)">
                mdi-pencil
              </v-icon>
            </template>
            <template v-slot:no-data>
              <v-alert :value="true" color="#111c3d" icon="mdi-alert" outlined
                >No se encontro su busqueda</v-alert
              >
            </template>
          </v-data-table>
          <!-- alertas de las acciones que se hacen -->
          <v-snackbar
            v-model="snackbar"
            :bottom="y === 'bottom'"
            :left="x === 'left'"
            :multi-line="mode === 'multi-line'"
            :right="x === 'right'"
            :timeout="timeout"
            :top="y === 'top'"
            :vertical="mode === 'vertical'"
            color="#294697"
            style="color: white"
          >
            {{ text }}
            <v-btn color="#294697" depressed dark @click="snackbar = false"
              >Cerrar</v-btn
            >
          </v-snackbar>
        </v-card>
      </v-flex>
    </v-layout>
  </div>
</template>

<script>
import axios from "axios";
import env from "../env";
export default {
  data() {
    return {
      show: false,
      snackbar: false,
      y: "top",
      x: null,
      mode: "",
      timeout: 6000,
      text: "",
      search: "",      
      apps: [],
      empresas: [],
      prioridad: [
        {
          prioridad: "BAJA",
        },
        {
          prioridad: "MEDIA",
        },
        {
          prioridad: "ALTA",
        },
      ],
      rules: {
        required: (value) => !!value || "Required.",
        counter: (value) => value.length <= 20 || "Maximo 20 characteres",
        email: (value) => {
          const pattern =
            /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
          return pattern.test(value) || "Invalido e-mail.";
        },
      },
      dialog: false,
      headers: [
        {
          text: "ID",
          align: "left",
          value: "idPunto",
          align: "center",
          class: "column",
        },
        {
          text: "Punto",
          value: "nombre",
          align: "center",
          class: "column",
        },
        {
          text: "Direccion",
          value: "direccion",
          align: "center",
          class: "column",
        },
        {
          text: "Empresa",
          value: "nombreEmpresa",
          align: "center",
          class: "column",
        },
        {
          text: "COdigo Seta",
          value: "codigoseta",
          align: "center",
          class: "column",
        },
        {
          text: "Acciones",
          value: "action",
          align: "center",
          class: "column",
        },
      ],
      defaultItem: {
        id: "",
        nombre: "",
        direccion: "",
        prioridad: "",
        codigoseta: "",
        idEmpresa: "",
      },
      editedIndex: -1,
      editedItem: {
        id: "",
        nombre: "",
        direccion: "",
        prioridad: "",
        codigoseta: "",
        idEmpresa: "",
      },
    };
  },
  computed: {
    formTitle() {
      return this.editedIndex === -1 ? "Nuevo Punto" : "Editar Punto";
    },
  },
  watch: {
    dialog(val) {
      val || this.close();
    },
  },

  mounted() {
    this.obtenerPuntos();
    this.obtenerEmpresas();
  },

  methods: {
    // Metodo para obtener las aplicaciones
    obtenerPuntos() {
      axios
        .get(`${env.endpoint}user/puntostodos`)
        .then((res) => (this.apps = res.data));
    },
    /**
     * Metodo para obtener las empresas
     */
    obtenerEmpresas() {
      axios.get(`${env.endpoint}user/empresas`).then((res) => {
        this.empresas = res.data;
        // console.log("empresas", this.empresas);
      });
    },

    /**
     * Metodo para agregar fila de la tabla en la modal
     */
    editItem(item) {
      this.editedIndex = this.apps.indexOf(item);
      this.editedItem = Object.assign({}, item);
      this.dialog = true;
    },

    /**
     * Metodo para cerrar la modal
     */
    close() {
      this.dialog = false;
      setTimeout(() => {
        this.editedItem = Object.assign({}, this.defaultItem);
        this.editedIndex = -1;
      }, 300);
    },

    /**
     * Metodo para guardar y actualizar
     */
    save() {
      if (this.editedIndex > -1) {
        const puntoVenta = JSON.stringify({
          nombre: this.editedItem.nombre,
          direccion: this.editedItem.direccion,
          prioridad: this.editedItem.prioridad,
          codigoseta: this.editedItem.codigoseta,
          idEmpresa: this.editedItem.idEmpresa
        });
        axios
          .get(`${env.endpoint}user/edit_punto?punto=${puntoVenta}&id=${this.editedItem.idPunto}`)
          .then((res) => {
            if (res.data.mensaje === "punto editado") {
              this.snackbar = true;
              this.text = "Punto actualizado satisfactoriamente";
            } else if (res.data.mensaje === "error en el registro") {
              this.snackbar = true;
              this.text = "Error al actualizar o codigo Seta Duplicado";
            } else {
              this.test =
                "Ha ocurrido un error que no se puede identificar, intente nuevamente";
              this.snackbar = true;
            }
          })
          .finally(() => {
            this.close();
            this.obtenerPuntos();
          });

        // console.log(puntoVenta);
      } else {
        // console.log("guardar");
        // obtiene los datos del arreglo para despues setearlos en una variable nuevoUsuario y pasarselo al metodo
        const nuevoPunto = JSON.stringify({
          nombre: this.editedItem.nombre,
          direccion: this.editedItem.direccion,
          prioridad: this.editedItem.prioridad,
          codigoseta: this.editedItem.codigoseta,
          idEmpresa: this.editedItem.idEmpresa,
        });
        // se crea el usuario
        axios
          .get(`${env.endpoint}user/create_punto?punto=${nuevoPunto}`)
          .then((res) => {
            if (res.data.mensaje === "punto registrado") {
              (this.snackbar = true),
                (this.text = "Punto registrado satisfactoriamente");
            } else if (res.data.mensaje === "error en el registro") {
              (this.snackbar = true), (this.text = "Error al registrar");
            } else if (res.data.mensaje === "error punto existe") {
              (this.snackbar = true),
                (this.text = "El punto ya existe o Codigo Seta duplicado");
            } else {
              this.test =
                "Ha ocurrido un error que no se puede identificar, intente nuevamente";
              this.snackbar = true;
            }
          })
          .finally(() => {
            this.close();
            this.obtenerPuntos();
          });
      }
    },
  },
};
</script>